import { Component, ElementRef, Inject, OnInit, ViewChild, AfterViewInit, NgZone } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import firebase from 'firebase/compat/app';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { trigger, style, transition, animate } from '@angular/animations';
import { Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

import { environment } from 'src/environments/environment';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-phone-auth',
  templateUrl: './phone-auth.component.html',
  styleUrls: ['./phone-auth.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule
  ],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('300ms ease-in', style({ transform: 'translateX(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-out', style({ transform: 'translateX(-100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class PhoneAuthComponent implements OnInit, AfterViewInit {
  @ViewChild('audioPlayer') audioPlayer!: ElementRef<HTMLAudioElement>;
  isPlaying: boolean = false;
  currentStep = 1;
    
  recaptchaVerifier: firebase.auth.RecaptchaVerifier | null = null;
  confirmationResult: firebase.auth.ConfirmationResult | null = null;
  verificationCode: string = ''; // Pour stocker le code OTP saisi par l'utilisateur
  phoneNumber: string = '';
  isCodeSent: boolean = false; // Pour suivre l'état de l'envoi du code

 
  selectedDialCode: string = "+223"; // Définir l'indicatif par défaut
  selectedCountry = {
    name: "Mali",
    dialCode: "+223",
    flag: "🇲🇱",
  }; // Initialisation du pays par défaut

  constructor(private afAuth: AngularFireAuth, private bottomSheetRef: MatBottomSheetRef<PhoneAuthComponent>, @Inject(MAT_BOTTOM_SHEET_DATA) public data: any, private ngZone: NgZone) {}

  ngOnInit(): void {
    this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
      size: 'invisible', 
      callback: (response: any) => {
        console.log('reCAPTCHA résolu avec succès', response);
      },
    });

    this.recaptchaVerifier.render().then(widgetId => {
      console.log('reCAPTCHA Widget ID:', widgetId);
    });

  }

    // Optionnel : Méthode pour gérer les changements de pays (si nécessaire)
  onCountryChange(event: any): void {
    const selectedOption = this.countries.find(
      (country) => country.dialCode === event.target.value
    );
    if (selectedOption) {
      this.selectedCountry = selectedOption;
      this.selectedDialCode = selectedOption.dialCode;
    }
  }

  ngAfterViewInit() {
    if (this.audioPlayer?.nativeElement) {
      this.setupAudioListeners();
      if (this.currentStep === 1) {
        this.startPlayback();
      }
    }
  }

  private setupAudioListeners() {
    const audio = this.audioPlayer?.nativeElement;
    if (!audio) return;

    audio.onplay = () => {
      this.ngZone.run(() => {
        console.log('Audio started playing');
        this.isPlaying = true;
      });
    };

    audio.onpause = () => {
      this.ngZone.run(() => {
        console.log('Audio paused');
        this.isPlaying = false;
      });
    };

    audio.onended = () => {
      this.ngZone.run(() => {
        console.log('Audio ended');
        this.isPlaying = false;
      });
    };
  }

  private startPlayback() {
    const audio = this.audioPlayer?.nativeElement;
    if (!audio) return;

    try {
      const playPromise = audio.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            console.log('Playback started successfully');
            this.isPlaying = true;
          })
          .catch(error => {
            console.error('Playback failed:', error);
            this.isPlaying = false;
          });
      }
    } catch (error) {
      console.error('Error starting playback:', error);
    }
  }

  sendOTP(phoneNumber: string): void {

    if (!this.selectedDialCode) {
      alert("Veuillez sélectionner un pays.");
      return;
    }

    if (!/^\d+$/.test(phoneNumber)) {
      alert("Veuillez entrer un numéro valide.");
      return;
    }
    
    
    const fullPhoneNumber = this.selectedDialCode + phoneNumber; // Combine l'indicatif et le numéro
    console.log("Numéro complet :", fullPhoneNumber);


    if (!this.recaptchaVerifier) {
      console.error('reCAPTCHA non configuré correctement.');
      return;
    }

    const auth = firebase.auth(); 
    auth.signInWithPhoneNumber(fullPhoneNumber, this.recaptchaVerifier)
      .then((confirmationResult) => {
        console.log('Code envoyé avec succès !');
        this.confirmationResult = confirmationResult;
        this.isCodeSent = true; // Le code est envoyé, permettez à l'utilisateur d'entrer l'OTP
        this.currentStep = 2; // Passe à l'étape 2
        // Attendre que le DOM soit mis à jour
        setTimeout(() => {
          if (this.audioPlayer?.nativeElement) {
            this.setupAudioListeners();
            this.startPlayback();
          }
        }, 100);
      })
      .catch((error) => {
        console.error('Erreur lors de l’envoi du code OTP :', error);
      });
  }

  verifyCode(): void {
    if (!this.confirmationResult) {
      console.error('Aucune confirmation de code disponible.');
      return;
    }

    this.confirmationResult.confirm(this.verificationCode)
      .then((result) => {
        this.bottomSheetRef.dismiss();
        console.log('Utilisateur authentifié avec succès :', result.user);
        // Vous pouvez rediriger l'utilisateur ou afficher un message de succès ici
        
      })
      .catch((error) => {
        console.error('Échec de la vérification du code OTP :', error);
      });
  }

  toggleAudio(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    
    console.log('Toggle audio clicked');
    const audio = this.audioPlayer?.nativeElement;
    if (!audio) {
      console.error('Audio element not found');
      return;
    }

    try {
      if (audio.paused) {
        console.log('Attempting to play');
        audio.play()
          .then(() => {
            console.log('Play successful');
            this.ngZone.run(() => this.isPlaying = true);
          })
          .catch(error => {
            console.error('Play failed:', error);
            this.ngZone.run(() => this.isPlaying = false);
          });
      } else {
        console.log('Attempting to pause');
        audio.pause();
        this.ngZone.run(() => this.isPlaying = false);
      }
    } catch (error) {
      console.error('Error in toggleAudio:', error);
    }
  }

  countries = [
    { name: "France", dialCode: "+33", flag: "🇫🇷" },
    { name: "United States", dialCode: "+1", flag: "🇺🇸" },
    { name: "Canada", dialCode: "+1", flag: "🇨🇦" },
    { name: "Germany", dialCode: "+49", flag: "🇩🇪" },
    { name: "India", dialCode: "+91", flag: "🇮🇳" },

    { name: "Afrique du Sud", dialCode: "+27", flag: "🇿🇦" },
  { name: "Algérie", dialCode: "+213", flag: "🇩🇿" },
  { name: "Angola", dialCode: "+244", flag: "🇦🇴" },
  { name: "Bénin", dialCode: "+229", flag: "🇧🇯" },
  { name: "Botswana", dialCode: "+267", flag: "🇧🇼" },
  { name: "Burkina Faso", dialCode: "+226", flag: "🇧🇫" },
  { name: "Burundi", dialCode: "+257", flag: "🇧🇮" },
  { name: "Cameroun", dialCode: "+237", flag: "🇨🇲" },
  { name: "Cap-Vert", dialCode: "+238", flag: "🇨🇻" },
  { name: "Comores", dialCode: "+269", flag: "🇰🇲" },
  { name: "Côte d'Ivoire", dialCode: "+225", flag: "🇨🇮" },
  { name: "Djibouti", dialCode: "+253", flag: "🇩🇯" },
  { name: "Égypte", dialCode: "+20", flag: "🇪🇬" },
  { name: "Érythrée", dialCode: "+291", flag: "🇪🇷" },
  { name: "Eswatini", dialCode: "+268", flag: "🇸🇿" },
  { name: "Éthiopie", dialCode: "+251", flag: "🇪🇹" },
  { name: "Gabon", dialCode: "+241", flag: "🇬🇦" },
  { name: "Gambie", dialCode: "+220", flag: "🇬🇲" },
  { name: "Ghana", dialCode: "+233", flag: "🇬🇭" },
  { name: "Guinée", dialCode: "+224", flag: "🇬🇳" },
  { name: "Guinée-Bissau", dialCode: "+245", flag: "🇬🇼" },
  { name: "Guinée équatoriale", dialCode: "+240", flag: "🇬🇶" },
  { name: "Kenya", dialCode: "+254", flag: "🇰🇪" },
  { name: "Lesotho", dialCode: "+266", flag: "🇱🇸" },
  { name: "Liberia", dialCode: "+231", flag: "🇱🇷" },
  { name: "Libye", dialCode: "+218", flag: "🇱🇾" },
  { name: "Madagascar", dialCode: "+261", flag: "🇲🇬" },
  { name: "Malawi", dialCode: "+265", flag: "🇲🇼" },
  { name: "Mali", dialCode: "+223", flag: "🇲🇱" },
  { name: "Maroc", dialCode: "+212", flag: "🇲🇦" },
  { name: "Maurice", dialCode: "+230", flag: "🇲🇺" },
  { name: "Mauritanie", dialCode: "+222", flag: "🇲🇷" },
  { name: "Mozambique", dialCode: "+258", flag: "🇲🇿" },
  { name: "Namibie", dialCode: "+264", flag: "🇳🇦" },
  { name: "Niger", dialCode: "+227", flag: "🇳🇪" },
  { name: "Nigeria", dialCode: "+234", flag: "🇳🇬" },
  { name: "Ouganda", dialCode: "+256", flag: "🇺🇬" },
  { name: "Rwanda", dialCode: "+250", flag: "🇷🇼" },
  { name: "Sao Tomé-et-Principe", dialCode: "+239", flag: "🇸🇹" },
  { name: "Sénégal", dialCode: "+221", flag: "🇸🇳" },
  { name: "Seychelles", dialCode: "+248", flag: "🇸🇨" },
  { name: "Sierra Leone", dialCode: "+232", flag: "🇸🇱" },
  { name: "Somalie", dialCode: "+252", flag: "🇸🇴" },
  { name: "Soudan", dialCode: "+249", flag: "🇸🇩" },
  { name: "Soudan du Sud", dialCode: "+211", flag: "🇸🇸" },
  { name: "Tanzanie", dialCode: "+255", flag: "🇹🇿" },
  { name: "Tchad", dialCode: "+235", flag: "🇹🇩" },
  { name: "Togo", dialCode: "+228", flag: "🇹🇬" },
  { name: "Tunisie", dialCode: "+216", flag: "🇹🇳" },
  { name: "Zambie", dialCode: "+260", flag: "🇿🇲" },
  { name: "Zimbabwe", dialCode: "+263", flag: "🇿🇼" },
    // Ajoutez tous les autres pays ici
  ];
}
